// context in this function is set when pusher channel is bound in Activity component
export function mentorNotificationPusherCallback(data) {
  const { dispatch, actions } = this

  if (data.activity.approved_by) {
    dispatch(
      actions.mentorApprovedActivity(
        data.activity.id,
        data.activity.approved_by
      )
    )
  } else {
    dispatch(
      actions.mentorRejectedActivity(
        data.activity.id,
        data.activity.disapproved_by
      )
    )
  }
}

export const displayJustForMentorInfo = (activity, activityNotes, isMentor) =>
  isMentor &&
  activity &&
  (activity.mentor_assessment_questions ||
    (activity.notes && activity.notes !== '') ||
    (activityNotes && activityNotes.length > 0))
